import $Jq from "jquery";
export default function addHtmlAndBody(content){
    let html = content.replace(/html/g,"rmthtml");
    html = html.replace(/body/g,"rmtbody");
    return html
}